module.exports = __webpack_public_path__ + "img/jhon.049048b4.jpeg";